'use client';
import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
import { useAuthContext } from '@/components/AuthProvider';
import { useLanguage } from '@/components/LanguageProvider';
import { useServerIp } from '@/hooks/useServerIp'; 


export function AmbientLight() {
  return (
    <div className="absolute inset-0 pointer-events-none z-[-1] overflow-clip rounded-b-[20px] md:rounded-b-[40px]">
      <div className="sticky top-0 w-full h-screen bg-[#111111]">
        <div className="absolute top-[-10%] left-[-10%] w-[60vw] h-[60vw] bg-[radial-gradient(circle_at_center,_rgba(102,127,255,0.04)_0%,_transparent_60%)]" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[50vw] h-[50vw] bg-[radial-gradient(circle_at_center,_rgba(82,107,235,0.03)_0%,_transparent_60%)]" />
      </div>
    </div>
  );
}


export function StickyBottomPanel() {
  const { t } = useLanguage();
  const tl = t.landing;
  
  const { javaIp } = useServerIp();

  const [isVisible, setIsVisible] = useState(false);
  const [stickyCopied, setStickyCopied] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const heading = document.getElementById('about-heading');
      if (heading) {
        const rect = heading.getBoundingClientRect();
        setIsVisible(rect.top < window.innerHeight * 0.4);
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const copyStickyIp = () => {
    navigator.clipboard.writeText(javaIp);
    setStickyCopied(true);
    setTimeout(() => setStickyCopied(false), 2000);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 50, opacity: 0 }}
          transition={{ type: "spring", stiffness: 400, damping: 25 }}
          className="vw-97legi shadow-[0_20px_60px_rgba(0,0,0,0.6)]"
        >
          <button data-track="ip_button_clicked" data-track-label="ip copy" type="button" className="vw-k5dpkc cursor-pointer" onClick={copyStickyIp}>
            <span className="vw-tegvy6 font-mc uppercase text-[15px] pt-1 tracking-wider cursor-pointer">
              {stickyCopied ? tl.hero.copied : javaIp}
            </span>
          </button>
          
          <a href="#access" className="vw-1aj4o6k cursor-pointer">
            <span className="vw-3u6176 font-mc uppercase text-[15px] pt-1 tracking-wider flex items-center gap-1.5 cursor-pointer">
              {tl.hero.playBtn} <ChevronRight size={18} className="-mr-2 mb-[2px]" />
            </span>
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
}